import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CloneIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 2 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <rect x="9" y="9" width="10" height="10" rx="2" stroke={color} strokeWidth={strokeWidth} fill="none" />
      <rect x="5" y="5" width="10" height="10" rx="2" stroke={color} strokeWidth={strokeWidth} fill="none" />
    </BaseIcon>
  ),
);

CloneIcon.displayName = 'CloneIcon';
